import Helper from './Helper';

class AnimationsOnScroll {
  constructor(config = {}) {
    let s = [
      '.ns-section > .ns-title-h1',
      '.ns-section > .ns-lead',
      '.ns-section > .ns-img',
      '.ns-section > .ns-quote',
      '.ns-section > .ns-tiles .ns-tiles__item',
      '.ns-section > .ns-quote',
      '.ns-section > .ns-keyfigures .ns-keyfigures__item',
      '.ns-section > .ns-graphic-keyfigure-wrapper',
      '.ns-section > .ns-milestones .ns-milestones__item',
      '.ns-section > .ns-title-h1-front',
      '.ns-section > .ns-marginal-container',
      '.ns-section > .ns-graphic--animated .ns-graphic__wrapper',
      '.single .ns-graphic--animated .ns-graphic__wrapper'
    ]

    //the list of Elements, which need to be wrapped in a span element. So its possible to have an effect if the text fades out of a box
    let s2 = [
      '.ns-section > .ns-title-h1',
      '.ns-section > .ns-title-h2',
      '.ns-section > .ns-lead',
    ]

    const selectors = s.join(',');
    const selectors2 = s2.join(',');

    const elements = Array.prototype.slice.call(document.querySelectorAll(selectors));
    const elements2 = Array.prototype.slice.call(document.querySelectorAll(selectors2));

    elements2.forEach(el => {
      const wrapper = document.createElement('span');
      wrapper.innerHTML = el.innerHTML;
      el.innerHTML = '';
      el.appendChild(wrapper);
    });

    elements.forEach(e => {
      e.classList.add('animate');
      Helper.loadImagesInDomElement(e);
    });

    this.handleScroll(elements);

    window.addEventListener("scroll", e => {
      this.handleScroll(elements);
    });
  }

  handleScroll(elements){
    elements.forEach(e => {
      if(Helper.jizzInViewport(e)){
        e.classList.add('animated');
      }
    });
  }
}

export default AnimationsOnScroll;
